
















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class CustomButton extends Vue {
  @Prop({ required: false, default: null })
  private label!: string;

  @Prop({ required: false, default: false })
  private isText!: boolean;

  @Prop({ required: false, default: null })
  private icon!: string;

  @Prop({ required: false, default: null })
  private btnColor!: string;

  @Prop({ required: false, default: false })
  private hasOutline!: boolean;

  @Emit('click')
  private click(): void {}
}
